const Module4Config = {
  day1: {
    learn: {
      video: 'Module4Videos/learn_day_1.mp4',
      song: 'appfiles/posture/school_photo_montage_music_1.m4a',
      json: 'appfiles/posture/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_day_1.mp4',
    },
    rewardOption1: 'Lion',
    rewardOption2: 'Cheetah',
  },
  day2: {
    learn: {
      video: 'Module4Videos/learn_day_2.mp4',
      song: 'appfiles/posture/school_photo_montage_music_2.m4a',
      json: 'appfiles/posture/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_day_2.mp4',
    },
    rewardOption1: 'Parrot',
    rewardOption2: 'Tucan',
  },
  day3: {
    learn: {
      video: 'Module4Videos/learn_day_3.mp4',
      song: 'appfiles/posture/school_photo_montage_music_3.m4a',
      json: 'appfiles/posture/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_day_3.mp4',
    },
    rewardOption1: 'JeepBlue',
    rewardOption2: 'JeepPink',
  },
  day4: {
    introVideo: 'Module4Videos/welcome_day_4.mp4',
    rewardOption1: 'Zebras',
    rewardOption2: 'Elephants',
    photoTime: {
      video1: 'Module4Videos/photo_time_1.mp4',
      video2: 'Module4Videos/photo_time_3.mp4',
      video3: 'Module4Videos/photo_time_2.mp4',
    },
    singingTime: {
      intro: 'Module4Videos/singing_time.mp4',
      demoMusic: '',
      singAlongMusic: 'appfiles/posture/posture_student_singalong.m4a',
      instrumentalMusic: 'appfiles/posture/posture_student_instrumental.m4a',
      singingAlongVideo: 'appfiles/posture/singingtime_posture_demo.mp4',
      instrumentalVideo: 'appfiles/posture/singingtime_posture_karaoke.mp4',
    },
  },
  day5: {
    introVideo: 'Module4Videos/welcome_day_5.mp4',
    rewardOption1: 'DrumPink',
    rewardOption2: 'DrumBlue',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_intro_day_5.mp4',
      afterVideo: 'Module4Videos/celebrate_close_day_5.mp4',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I can do it all!"',
      name: 'posture_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption1: 'Hippo',
    rewardOption2: 'Flamingos',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_intro_day_6.mp4',
      afterVideo: 'Module4Videos/celebrate_close_day_6.mp4',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I can do it all!"',
      name: 'posture_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption1: 'Camera',
    rewardOption2: 'Binoculars',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_intro_day_7.mp4',
      afterVideo: 'Module4Videos/celebrate_close_day_7.mp4',
      animal: true,
      text: 'Record yourself singing, "I can do it all!"',
      name: 'posture_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption1: 'Ostrich',
    rewardOption2: 'Giraffe',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_intro_day_8.mp4',
      afterVideo: 'Module4Videos/celebrate_close_day_8.mp4',
      animal: true,
      text: 'Record yourself making a silly face and say, "I can do it all!"',
      name: 'posture_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: 'Module4Videos/closing.mp4',
    rewardOption1: 'Hat',
    rewardOption2: 'Bowtie',
    learn: {
      recording: 'userfiles/{student-id}/posture_play_day_music.m4a',
      video: 'influencers/{influencer-id}/respond_affirmation.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      demoSong: 'appfiles/posture/posture_student_singalong.m4a',
      json: 'appfiles/posture/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: 'Module4Videos/celebrate_intro_day_9.mp4',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I can do it all!"',
      name: 'posture_celebration_surprise_9.mp4',
    },
    surprise: {
      video: 'Module4Videos/surprise.mp4',
      song: 'appfiles/posture/posture_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/respond_affirmation.mp4',
        'userfiles/{student-id}/posture_celebration_surprise_6.mp4',
        'userfiles/{student-id}/posture_smile.jpg',
        'influencers/{influencer-id}/posture_video_message.mp4',
        'userfiles/{student-id}/posture_celebration_surprise_8.mp4',
        'userfiles/{student-id}/posture_silly_photo_3.jpg',
        'userfiles/{student-id}/posture_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module4Config;
